import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to an error reporting service
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4">
          <div className="w-full max-w-md p-6 rounded-lg shadow-lg bg-white">
            <h1 className="text-2xl font-bold text-center text-red-600 mb-4">Something went wrong</h1>
            <div className="bg-gray-50 p-4 rounded mb-6">
              <p className="text-gray-800 mb-2">
                {this.state.error && this.state.error.toString()}
              </p>
              <div className="text-xs font-mono overflow-auto max-h-40 bg-gray-100 p-2 rounded">
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </div>
            </div>
            <div className="flex flex-col gap-3 mt-4">
              <button 
                onClick={() => window.location.reload()}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded shadow transition-colors"
              >
                Reload Page
              </button>
              <Link 
                to="/" 
                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded text-center shadow transition-colors"
              >
                Return to Homepage
              </Link>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 